export default "__VITE_ASSET__D1bkDEoe__"